import { useSyncExternalStore } from 'react';
import type { Identity, Names, People } from '@snapshots/domain';

type Text = (key: string, values?: Record<string, string | number>) => string;

/**
 * A person a page mentions, by name and never by identifier: "You" for the person reading, their name once
 * the directory gives it, or "A member of {organization}" without it. The identifier is for "Technical
 * details" only. A cell is drawn once, so it follows names learned after it.
 */
export function Who({ account, organization, identity, people, names, text }: { account?: string; organization?: string; identity?: Identity; people: People; names: Names; text: Text }) {
	const name = useSyncExternalStore(people.listen, () => people.name(account));
	if (!account) return <>—</>;
	if (account === identity?.account) return <span data-person="you">{text('person.you')}</span>;
	if (name) return <span data-person={account}>{name}</span>;
	const place = names.name(organization);
	return <span data-person={account}>{place ? text('person.member', { organization: place }) : text('person.someone')}</span>;
}
